module.exports = __webpack_public_path__ + "img/exp3.0f5d843e.png";